module.exports = function (form) {
    var $form = form.getFormElem();
    var mouseFlowFormId = '#' + $form[0].id;
    var formId = form.getId();

    form.onSubmit(function (form) {
        window._mfq.push(['formSubmitAttempt', mouseFlowFormId]);
    });

    form.onValidate(function (validationStatus) {
        if (!validationStatus) {
            window._mfq.push(['formSubmitFailure', mouseFlowFormId]);
        }        
    });

    form.onSuccess(function (vals, followUpUrl) {
        try {
            window._mfq.push(['formSubmitSuccess', mouseFlowFormId]);

            var formName = '';
            var personalizationRuleName = '';
            
            var $marketoForm = $form.closest('.marketo-form');
            
            var gatedRedirectUrl = $marketoForm.data('gatedRedirectUrl');
            if (gatedRedirectUrl == '') {
                gatedRedirectUrl = undefined;
            }

            var gatedResourceMediaId = $marketoForm.data('gatedResourceMediaId');
            if (gatedResourceMediaId == '') {
                gatedResourceMediaId = undefined;
            }

            var gatedResourceDownloadUrl = $marketoForm.data('gatedResourceDownloadUrl');
            if (gatedResourceDownloadUrl == '') {
                gatedResourceDownloadUrl = undefined;
            }

            var gatedVideoId = $marketoForm.data('gatedVideoId');
            if (gatedVideoId == '') {
                gatedVideoId = undefined;
            }

            var $embeddedSubscriptionModule = $form.closest('.embedded-subscription-module');
            if ($embeddedSubscriptionModule.length) {
                formName = $embeddedSubscriptionModule.find('h3').first().text();
                personalizationRuleName = $embeddedSubscriptionModule.data('personalizationRuleName');
            }
            else {
                var $insightsDetailForm = $form.closest('.insights-detail__form');
                if ($insightsDetailForm.length) {
                    formName = 'Resource Registration';
                }
                else {
                    if ($marketoForm.length) {
                        formName = $marketoForm.find('h2').first().text();
                        personalizationRuleName = $marketoForm.data('personalizationRuleName');

                        dataLayer.push({
                            event: 'formSubmissionSuccess',
                            formName: formName,
                            data: vals,
                            formId: formId,
                            personalizationRuleName: personalizationRuleName
                        });
                    }
                }
            }

            if (gatedRedirectUrl || gatedVideoId || gatedResourceMediaId) {
                dataLayer.push({
                    'event': 'resourceRegistrationComplete',
                    formId: formId
                });
            }

            dataLayer.push({
                event: 'formSubmission',
                formName: formName,
                data: vals,
                formId: formId,
                personalizationRuleName: personalizationRuleName
            });

            var $customSuccessFormContainer = $form.closest('[data-on-success]');
            if ($customSuccessFormContainer.length) {
                var formSuccessFunctionName = $customSuccessFormContainer.data('onSuccess');

                if (formSuccessFunctionName != undefined) {
                    var customOnSuccess = undefined;

                    var current = window.ICF;
                    var formSuccessFunctionPaths = formSuccessFunctionName.split('.');

                    for (var i = 0; i < formSuccessFunctionPaths.length; ++i) {
                        var pathElement = formSuccessFunctionPaths[i];
                        if (pathElement === 'ICF') {
                            continue;
                        }

                        current = current[pathElement];
                    }

                    var formSuccessFunction = current(form);

                    customOnSuccess = formSuccessFunction(vals, $formContainer, followUpUrl);
                    if (customOnSuccess !== undefined && !customOnSuccess) {
                        return false;
                    }
                }
            }

            var urlMediaId = ICF.Utils.GetUrlParameter('mediaId');
            var urlGatingFormId = ICF.Utils.GetUrlParameter('gatingFormId');

            if (urlMediaId && urlGatingFormId) {
                $.post('/icfapi/gating/registercompletion?mediaId=' + urlMediaId + '&gatingFormId=' + urlGatingFormId, function () {
                    var followUpUrl = URI(followUpUrl);
                    followUpUrl.setQuery('mediaId', urlMediaId);
                    window.location.href = followUpUrl;
                });

                return false;
            }
            else if (gatedVideoId) {
                $.post('/icfapi/analytics/trackgoal?goalId={6F630192-7305-4076-BFEF-AB1BFC947D1B}');

                var followUpUrl = URI(window.location.href);
                followUpUrl.setQuery('success', true);
                followUpUrl.setQuery('video', gatedVideoId)

                window.location.href = followUpUrl;
                return false;
            }
            else if (gatedResourceMediaId && !(followUpUrl && followUpUrl.length) && gatedResourceDownloadUrl) {
                $form.html('<h2>Register to Download</h2><p class="marketo-form-success-text">Thank you for downloading! Your copy will download automatically. We have also emailed you the download link.<br/><br/>If your download did not start automatically, <a target="_blank" href="' + gatedResourceDownloadUrl + '">click here to download</a>.</p>');
                
                var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                if (isIOS) {
                    window.location.href = gatedResourceDownloadUrl;
                }
                else {
                    document.getElementById('resourceDownloadLink').click();
                }

                $("body").css("cursor", "");
                return false;
            }

            var updatedFollowUpUri;

            if (gatedRedirectUrl) {
                if (gatedRedirectUrl[0] == '/') {
                    updatedFollowUpUri = URI(URI(window.location.href).origin() + gatedRedirectUrl);

                }
                else {
                    updatedFollowUpUri = URI(gatedRedirectUrl);
                }                
            }
            else if (followUpUrl && followUpUrl.length) {
                updatedFollowUpUri = URI(followUpUrl);
            }

            if (updatedFollowUpUri && updatedFollowUpUri.toString().length) {
                if (window.sourcePageId) {
                    updatedFollowUpUri.setQuery('sourcePageId', window.sourcePageId);
                }

                if (gatedResourceMediaId) {
                    updatedFollowUpUri.setQuery('mediaId', gatedResourceMediaId);
                }

                window.location.href = updatedFollowUpUri;
                return false;
            }
        }
        catch (error) {
            console.log(error);
        }
    });
}